export const ALERT_TIMEOUT = 6000;
export const MESSAGE_TIMEOUT = 5000;
//export const backendHOST = 'https://scriptantialearning.azurewebsites.net';
export const backendHOST = process.env.REACT_APP_BACKEND_HOST
  ? process.env.REACT_APP_BACKEND_HOST
  : 'https://scriptantialearning.azurewebsites.net';
//= 'http://localhost:5050';
export const LANG = 'HU';
export const CloudinaryColudName = 'Scriptantia';
